import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DataService {
  public cart: any;
  public current_quote: any;
  public current_mc: any;
  public cost: any;
  public GTM: any;
  public progress: any;

  private quoteSource = new BehaviorSubject(0);
  private mcSource = new BehaviorSubject(0);
  private costSource = new BehaviorSubject(0);
  private progSource = new BehaviorSubject(0);
  private gtmSource = new BehaviorSubject(0);
  private cartSource = new BehaviorSubject(0);
  private membershipTabSource = new BehaviorSubject<'covered' | 'compare'>('covered');

  quote = this.quoteSource.asObservable();
  mc = this.mcSource.asObservable();
  c = this.costSource.asObservable();
  ct = this.cartSource.asObservable();
  pr = this.progSource.asObservable();
  gt = this.gtmSource.asObservable();
  membershipTab = this.membershipTabSource.asObservable();

  constructor() {}

  public setQuote(quote) {
    this.current_quote = quote;
  }

  public getQuote() {
    return this.current_quote;
  }

  public changeQuotes(quote: any) {
    this.quoteSource.next(quote);
  }

  public setCart(ct) {
    this.cart = ct;
  }

  public getCart() {
    return this.cart;
  }

  public changeCarts(ct: any) {
    this.cartSource.next(ct);
  }

  public setMembershipCost(mc) {
    this.current_mc = mc;
  }

  public getMembershipCost() {
    return this.current_mc;
  }

  public changeMembershipCost(mc: any) {
    this.mcSource.next(mc);
  }

  public setCost(c) {
    this.cost = c;
  }

  public getCost() {
    return this.cost;
  }

  public changeCost(c: any) {
    this.costSource.next(c);
  }

  public getProgress() {
    return this.progress;
  }

  public updateProgress(p: any) {
    this.progress = p;
    this.progSource.next(p);
  }

  public setGTM(data) {
    this.GTM = data;
  }

  public getGTM() {
    return this.GTM;
  }

  public changeGTM(data: any) {
    this.gtmSource.next(data);
  }

  public setMembershipTab(tab: 'covered' | 'compare') {
    this.membershipTabSource.next(tab);
  }

  public getMembershipTab(): 'covered' | 'compare' {
    return this.membershipTabSource.getValue();
  }
}
